import Main from '../../types/enums/main';
import Rail from '../../classes/rail';
import addonContentRequest from './addonContentRequest';
import channelsAddonsRequest from '../moreContent/channelsAddonsRequest';
import generateChannelsRailsWithData from '../../utils/generic/generateChannelsRailsWIthData';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

export function addonContentObservable(
  addonId: string,
  planId?: string,
  title?: string
) {
  return new Observable((subscriber) => {
    let data: Rail[] = [];
    channelsAddonsRequest(addonId, false, planId).then((channelList) => {
      const [channelRail] = generateChannelsRailsWithData(
        channelList || [],
        title
      );
      if (channelRail?.data?.length) {
        data = data.concat(channelRail);
      }
      addonContentRequest(addonId).then((contentData) => {
        setTimeout(() => {
          if (contentData.length) {
            data = data.concat(contentData);
          }
          subscriber.next({ data, type: Main.RAILS });
          subscriber.complete();
        }, WAITING_TIME);
      });
    });
  });
}

export default addonContentObservable;
